module.exports = __webpack_public_path__ + "img/six-page-bg-zh.305f1136.png";